// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { summaryTableStyles } from "@tps/Overrides/Widgets/OrderDetails/OrderDetailsSummaryTable";
import { css } from "styled-components";

summaryTableStyles.orderLines = {
    gridContainer: {
        css: css`
            .card_container__wrapper {
                border-top: 1px solid ${getColor("common.border")};
            }
            .card_container__wrapper ~ .card_container__wrapper {
                border-top: none;
            }
            @media print {
                float: left;
                margin-top: 25px;
                margin-bottom: 25px;
            }
        `,
    },
};

summaryTableStyles.spinner = {
    css: css`
        margin: auto;
    `,
};

summaryTableStyles.centeringWrapper = {
    css: css`
        height: 300px;
        display: flex;
        align-items: center;
    `,
};
